<template>
  <v-select
    v-if="selectLists"
    v-bind="$attrs"
    v-model="input"
    :items="selectLists.ServiceTypes"
    item-text="Text"
    item-value="Value"
    :label="label"
    dense
  >
    <template v-slot:item="{ item }">
      <v-icon small :color="feature.services.color">{{ item.IconName }}</v-icon>
      <div class="ml-1">{{ item.Text }}</div>
    </template>
    <template v-slot:selection="{ item }">
      <v-icon small :color="feature.services.color">{{ item.IconName }}</v-icon>
      <div class="ml-1">
        {{ item.Text }}
      </div>
    </template>
  </v-select>
</template>

<script>
import { ref, watch } from 'vue'
import { selectListCache } from '@/services/SelectListCache'
import { feature } from '@/use/Constants'
export default {
  name: 'ServiceTypePicker',
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Service Type'
    }
  },
  setup(props, context) {
    const input = ref()
    const selectLists = ref()

    watch(
      () => props.value,
      newVal => {
        input.value = newVal
      }
    )

    watch(
      () => input.value,
      newVal => {
        context.emit('input', newVal)
        context.emit('change', newVal)
      }
    )

    const initControl = async () => {
      input.value = props.value
      await loadSelectLists()
    }

    const loadSelectLists = async () => {
      const selectListNames = [selectListCache.name.ServiceTypes]

      selectLists.value = await selectListCache.get(selectListNames)
    }

    initControl()
    return { input, selectLists, feature }
  }
}
</script>

<style lang="scss" scoped></style>
